import { biaAccessTech } from "../types/index.const";

const biaAccessTechOptions = biaAccessTech.map((el) => ({
  value: el,
  label: el,
}));

export default biaAccessTechOptions;
